module.exports = {
  TheExpiredAndNoCreated: 'Договор с данной доверенной организацией истёк, создание новых операций невозможно!',
  NotTheCorrectOperationStatus: 'Не в рабочем состоянии.',
  NoDataSelected: 'Данные не выбраны',
  AllAreInNonStatus: 'Все выбранные записи данных находятся в нерабочем состоянии',
  ThisSelfConsolidationBuyerConsolidation: 'Тип консолидации данной операции не является самоконсолидацией, buyer consol или доверенной консолидацией',
  AttachmentContentTooLarge: 'Содержимое вложения слишком большое',
  AreWantToWithdrawBill: 'Вы уверены, что хотите отозвать данную операцию?',
  SplitOrder: 'Разделение заказа',
  MergeOrder: 'Объединение заказов',
  SRIFailedPleaseContactTroubleshooting: 'Ошибка отправки доверенной заявки SIRIUS, обратитесь к специалисту для проверки:',
  OperationSuccessful: 'Операция выполнена успешно',
  ContainerType: 'Тип контейнера',
  LockedPrintedPleaseContactUnlocking: 'Заблокировано, печать невозможна. Обратитесь к руководителю для разблокировки!',
  FullContainerProfitPrint: 'Печать прибыли по FCL',
  LCLProfitPrint: 'Печать прибыли по LCL',
  NoSubTicketSelected: 'Мини-накладная не выбрана',
  CustomersSuchAsPOEtc: 'Указывает внутренний номер клиента для грузоперевозки, например PO NBR, ITEM NBR и т.д.',
  OriginalBillOfLading: 'Оригинал',
  TelexRelease: 'Телекс релиз (Telex Release)',
  NoLoadingInformationSelected: 'Информация о контейнеризации не отмечена',
  PleaseASubTicketRecord: 'Пожалуйста, выберите запись мини-накладной',
  PleaseSelectAContainer: 'Пожалуйста, выберите контейнер',
  BillOfLadingInformationTracking: 'Отслеживание коносамента',
  ReleaseNumber: 'Номер релиза:',
  Unknown: 'Неизвестно',
  ViewExceptions: 'Просмотр аномалий',
  PleaseSelectDesignatedData: 'Пожалуйста, выберите указанные данные',
  LicenseOfLadingNumberEmpty: 'Номер автомобиля и номер коносамента не могут быть пустыми',
  NoRelevantInformationAvailable: 'Соответствующая информация отсутствует',
  DoToDeleteTheTicket: 'Удалить мини-накладную?',
  AuditSuccessful: 'Проверка успешно завершена',
  Allocation: 'Дистрибуция',
  ChangeOrders: 'Замена документов',
  ImportManifest: 'Импортный манифест'
}
